import React, { useEffect } from 'react';
import { type MsalAuthenticationProps } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '@/authConfig';

export const Error: MsalAuthenticationProps['errorComponent'] = ({ error }) => {
  const { instance } = useMsal();

  useEffect(() => {
    console.error('Authentication error:', error);

    // Redirect to the login page
    instance.loginRedirect(loginRequest);
  }, [instance, error]);

  return (
    <div>
      <p>An error occurred during authentication. Redirecting to login...</p>
      <p>Error: {error?.errorMessage}</p>
    </div>
  );
};
